module.exports = __webpack_public_path__ + "static/media/SJ.30e7ee2f.svg";